// extracted by mini-css-extract-plugin
export var description = "e_bg_bZ";
export var heroContent = "e_bg_cX";
export var heroText = "e_bg_cY";
export var inputContainer = "e_bg_c1";
export var layoutContainer = "e_bg_8";
export var layoutMaxWidth = "1080px";
export var middle = "e_bg_c0";
export var screenLaptop = "1024px";
export var screenMobileL = "425px";
export var screenTablet = "768px";
export var section = "e_bg_cW";
export var sectionContainer = "e_bg_9";
export var writter = "e_bg_cZ";